// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"0d1b4b5f","379":"c1bb5e7f","853":"797e8acf"}[chunkId] + ".chunk.css";
};